import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ChangeRfq, CustomerMyRfqsState, RfqQueryParameter, RfqsQuery } from "./models/models";
import customerRfqsApi from "./api/buyerRfqsApi";
import customerManufacturersApi from "../shared/api/customerManufacturersApi";
import customerCategoriesApi from "../shared/api/customerCategoriesApi";
import { VisibilityPresetCode } from "./shared/models/models";

export const getRfqs = createAsyncThunk(
  "customerMyRfqs/getRfqs",
  async (query: RfqsQuery) => {
    return customerRfqsApi.getRfqsAsync(query);
  }
);

export const createRfq = createAsyncThunk(
  "customerMyRfqs/createRfq",
  async (model: ChangeRfq) => {
    return customerRfqsApi.createRfqAsync(model);
  }
);

export const closeRfq = createAsyncThunk(
  "customerMyRfqs/closeRfq",
  async (id: string) => {
    return customerRfqsApi.closeRfq(id);
  }
);

export const deleteRfq = createAsyncThunk(
  "customerMyRfqs/deleteRfq",
  async (id: string) => {
    return customerRfqsApi.deleteRfq(id);
  }
);

export const getManufacturers = createAsyncThunk(
  "customerMyRfqs/getManufacturers",
  async () => {
    return customerManufacturersApi.getManufacturers();
  }
);

export const getCategories = createAsyncThunk(
  "customerMyRfqs/getCategories",
  async () => {
    return customerCategoriesApi.getCategories();
  }
);

const initialState: CustomerMyRfqsState = {
  query: {
    search: undefined,
    sortBy: RfqQueryParameter.productNumber,
    sortDesc: false,
    pageNo: 1,
    pageSize: 20,
    statusCodes: [],
    lastCallTo: undefined,
    visibilityCode: VisibilityPresetCode.all
  },
  rfqs: undefined,
  rfq: undefined,
  manufacturers: [],
  categories: [],
  loading: false,
  success: undefined,
  error: undefined
};

const customerMyRfqsSlice = createSlice({
  name: "customerMyRfqs",
  initialState: initialState,
  reducers: {
    changeRfqQuery: (state, action) => {
      state.query = action.payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getRfqs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRfqs.fulfilled, (state, { payload }) => {
        state.rfqs = payload;
        state.loading = false;
      })
      .addCase(getRfqs.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(createRfq.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRfq.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(createRfq.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getManufacturers.fulfilled, (state, { payload }) => {
        state.manufacturers = payload;
      });

    builder
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
      });
  }
});

export const {
  changeRfqQuery,
  setLoading,
  setSuccess,
  setError
} = customerMyRfqsSlice.actions;

export default customerMyRfqsSlice.reducer;